module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"popup":{"title":"Action unavailable","description":"Unfortunately, this candidate cannot be unarchived, as they are currently registered with another company.","gotIt":"Got it"}}}')
  delete Component.options._Ctor
}
